"use client";
import { jsxs as c, jsx as t, Fragment as W } from "react/jsx-runtime";
import _ from "clsx";
import b from "next/image";
import { memo as g, useState as N, isValidElement as D } from "react";
import { Box as w } from "../base/Base.js";
import { ButtonInfo as P } from "../../buttons/button/ButtonInfo.js";
import { ButtonWrapper as V } from "../../buttons/button/ButtonWrapper.js";
import '../../assets/ClothFilterBlock.css';const q = "_block_ndamg_1", z = "_title_ndamg_4", A = "__disabled_ndamg_14", G = "_set_ndamg_19", H = "_wrap_auto_ndamg_30", J = "_wrap_wrap_ndamg_38", K = "_wrap_nowrap_ndamg_41", M = "_category_ndamg_45", O = "_round_button_ndamg_45", Q = "_icon_ndamg_56", T = "_text_ndamg_63", U = "_small_ndamg_68", X = "_normal_ndamg_81", Y = "__active_ndamg_99", Z = "_badge_icon_ndamg_124", $ = "_item_ndamg_143", aa = "__wide_ndamg_168", ta = "_variant_image_ndamg_171", ea = "_variant_text_ndamg_177", na = "__gift_ndamg_183", _a = "__gold_ndamg_183", oa = "_badge_image_ndamg_269", sa = "_image_ndamg_277", ia = "__loading_ndamg_309", ca = "_rotation_ndamg_1", ra = "__status_ndamg_312", la = "_desc_ndamg_316", da = "_badge__new_ndamg_354", a = {
  block: q,
  title: z,
  _disabled: A,
  set: G,
  wrap_auto: H,
  wrap_wrap: J,
  wrap_nowrap: K,
  category: M,
  round_button: O,
  icon: Q,
  text: T,
  small: U,
  normal: X,
  _active: Y,
  badge_icon: Z,
  item: $,
  _wide: aa,
  variant_image: ta,
  variant_text: ea,
  _gift: na,
  _gold: _a,
  badge_image: oa,
  image: sa,
  _loading: ia,
  rotation: ca,
  _status: ra,
  desc: la,
  badge__new: da
}, ma = g(
  ({ title: e, disabled: n, children: o }) => /* @__PURE__ */ c(
    w,
    {
      gap: 12,
      className: _(a.block, { [a._disabled]: n }),
      children: [
        e && /* @__PURE__ */ t("span", { className: a.title, children: e }),
        o
      ]
    }
  )
);
ma.displayName = "ClothFilterBlock";
const ga = g(
  ({ wrap: e = "auto", className: n, children: o }) => /* @__PURE__ */ t(
    w,
    {
      row: !0,
      gap: 4,
      className: _(a.set, a["wrap_" + e], n),
      children: o
    }
  )
);
ga.displayName = "ClothFilterSet";
const pa = g(
  ({
    startContent: e,
    text: n,
    endContent: o,
    size: s = "normal",
    active: r,
    disabled: i,
    onClick: l,
    ...d
  }) => /* @__PURE__ */ c(
    "button",
    {
      className: _(a.category, a[s], {
        [a._active]: r,
        [a._disabled]: i
      }),
      onClick: l,
      ...d,
      children: [
        e && /* @__PURE__ */ t("span", { className: a.icon, children: e }),
        /* @__PURE__ */ t("span", { className: a.text, children: n }),
        o && /* @__PURE__ */ t("span", { className: a.icon, children: o })
      ]
    }
  )
);
pa.displayName = "ClothFilterCategory";
const ha = g(
  ({
    icon: e,
    text: n,
    size: o = "normal",
    active: s,
    disabled: r,
    badgeIcon: i,
    onClick: l,
    ...d
  }) => /* @__PURE__ */ c(
    "button",
    {
      className: _(a.round_button, a[o], {
        [a._active]: s,
        [a._disabled]: r
      }),
      onClick: l,
      ...d,
      children: [
        e ? /* @__PURE__ */ t("span", { className: a.icon, children: e }) : n && /* @__PURE__ */ t("span", { className: a.text, children: n }),
        i && v(i, "text")
      ]
    }
  )
);
ha.displayName = "ClothFilterRoundButton";
const ua = g(
  ({
    image: e,
    startContent: n,
    text: o,
    endContent: s,
    active: r,
    disabled: i,
    isGift: l,
    isGold: d,
    isNew: y,
    wide: f,
    badgeIcon: u,
    variant: m = "image",
    onClick: x,
    onInfo: p,
    className: F,
    style: C,
    ...k
  }) => {
    const [B, L] = N(!0), [E, S] = N(!1), I = () => {
      L(!1);
    }, j = () => {
      S(!0);
    }, R = (h) => {
      h.preventDefault(), h.stopPropagation(), p == null || p(h);
    };
    return /* @__PURE__ */ c(
      "div",
      {
        className: _(a.item, a["variant_" + m], {
          [a._active]: r,
          [a._disabled]: i,
          [a._gift]: l,
          [a._gold]: d,
          [a._wide]: f,
          className: F
        }),
        style: C,
        onClick: x,
        ...k,
        children: [
          /* @__PURE__ */ t("div", { className: _(a.image), children: m === "image" ? E ? /* @__PURE__ */ t(
            "span",
            {
              className: _("material-icons", a.icon, a._status),
              "data-icon": "no_photography"
            }
          ) : /* @__PURE__ */ c(W, { children: [
            B && /* @__PURE__ */ t(
              "span",
              {
                className: _(
                  "material-icons",
                  a.icon,
                  a._status,
                  a._loading
                ),
                "data-icon": "progress_activity",
                style: { opacity: 0.2 }
              }
            ),
            /* @__PURE__ */ t(
              b,
              {
                src: e,
                width: 100,
                height: 74,
                alt: "filter",
                onLoad: I,
                onError: j
              }
            )
          ] }) : /* @__PURE__ */ t("span", { className: _("material-icons", a.icon), children: e }) }),
          y && /* @__PURE__ */ t("div", { className: a.badge__new, children: "NEW" }),
          u && v(u, m),
          /* @__PURE__ */ t(V, { children: /* @__PURE__ */ c("div", { className: _(a.desc, a["variant_" + m]), children: [
            n && /* @__PURE__ */ t("span", { className: a.icon, children: n }),
            /* @__PURE__ */ t("span", { className: _(a.text, a["variant_" + m]), children: o }),
            s && /* @__PURE__ */ t("span", { className: a.icon, children: s }),
            p && /* @__PURE__ */ t(P, { icon: "info", onClick: R })
          ] }) })
        ]
      }
    );
  }
);
ua.displayName = "ClothFilterItem";
const v = (e, n) => D(e) ? e : typeof e == "string" ? /* @__PURE__ */ t(
  "div",
  {
    className: _(
      "material-icons",
      a.badge_icon,
      a["variant_" + n]
    ),
    "data-icon": e
  }
) : /* @__PURE__ */ t(
  b,
  {
    className: a.badge_image,
    src: e,
    height: 24,
    width: 24,
    alt: "icon"
  }
);
export {
  ma as ClothFilterBlock,
  pa as ClothFilterCategory,
  ua as ClothFilterItem,
  ha as ClothFilterRoundButton,
  ga as ClothFilterSet
};
